interface IConfigGrid {
  fixedColumnCount: number;
  fixedRowCount: number;
  height: number;
  rowCount: number;
}

export const getConfigGrid = (
  patients: IFormattedPatientType[],
): IConfigGrid => {
  if (patients.length === 0)
    return { fixedColumnCount: 2, fixedRowCount: 0, height: 100, rowCount: 1 };
  return {
    fixedColumnCount: 2,
    fixedRowCount: 1,
    height: 650,
    rowCount: patients.length + 1,
  };
};

export const getMaxLength = (patient: IFormattedPatientType): number => {
  const ignoreKeyLengthItem = {
    ...patient,
    key: '',
  };
  const lengthValues = Object.values(ignoreKeyLengthItem)
    .filter((v) => typeof v === 'string')
    // @ts-ignore
    .map((v) => v.length);

  const max = Math.max(...lengthValues);
  // extraHeight is to increase space between text and cell
  const extraHeight = 21;
  if (max > patient.email.length) return max + extraHeight;
  return max;
};
